module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/AddOnCoverSection/passenger-liability-f8d7b20dd7d6d513303a920a303da803.png";